import {format} from 'date-fns'

import {parseApiDate} from 'src/jobs/job-schedule-format'

import type {ActiveRental, ActiveRentalEquipment} from './schemas'

export function formatRentalDay(value: string): string {
    return format(parseApiDate(value), 'EEE MMM d')
}

export function equipmentLabel(line: ActiveRentalEquipment): string {
    const vendor = line.isRerent && line.vendorName ? ` · ${line.vendorName}` : ''
    const name = `${line.count} × ${line.rentalAssetTypeName}${line.isRerent ? ', re-rent' : ''}${vendor}`
    return line.unitNames.length > 0 ? `${name} (${line.unitNames.join(', ')})` : name
}

export function plannedEndLabel(row: ActiveRental): string {
    return row.plannedEndDate ? formatRentalDay(row.plannedEndDate) : 'No end date'
}

export function pickupLabel(row: ActiveRental): string {
    if (!row.pickup) {
        return 'None'
    }

    const when = row.pickup.startDate ? formatRentalDay(row.pickup.startDate) : 'Date TBC'
    return row.unitsNotOnPickup > 0 ? `${when} (${row.unitsNotOnPickup} not on it)` : when
}

export type ActiveRentalCounts = {
    jobs: number
    pastEndDate: number
    noEndDate: number
    noPickup: number
}

export function activeRentalCounts(rows: ActiveRental[]): ActiveRentalCounts {
    return {
        jobs: rows.length,
        pastEndDate: rows.filter((row) => row.pastEndDate).length,
        noEndDate: rows.filter((row) => row.plannedEndDate === null).length,
        noPickup: rows.filter((row) => row.pickup === null).length,
    }
}
